import React, { FC } from 'react'
import { Button, Row, Col, Form, Card } from 'react-bootstrap'
import MaskedInput from 'react-maskedinput'
import { Formik } from 'formik'
import { ContactInfoSchema } from '../../../../utils/validation'
import { isEmpty } from 'lodash'

import './index.css'

interface Props {
  initialValues: any;
  readonly: boolean;
  handleNext: (values: any) => void;
  handleBack: (values: any) => void;
  onSubmit: (values: any) => void;
}

const ContactInfo: FC<Props> = ({ initialValues, readonly, handleNext, handleBack, onSubmit }: Props) => {

  return (
    <div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={ContactInfoSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false)
          onSubmit(values)
        }}
      >
        {({ errors, values, handleChange, handleSubmit, setFieldValue, setFieldTouched, validateForm }) => {
          const handleNextClicked = async () => {
            const foundErrors = await validateForm()
            if (isEmpty(foundErrors)) {
              handleNext(values)
            }
          }

          const handleCheckboxChange = (key: string, val: boolean, values: any) => {
            setFieldValue(`${key}SameAsContracting`, val)
            setFieldValue(`${key}FirstName`, val ? values.contractingFirstName : '')
            setFieldValue(`${key}LastName`, val ? values.contractingLastName : '')
            setFieldValue(`${key}PhoneNumber`, val ? values.contractingPhoneNumber : '')
            setFieldValue(`${key}Extension`, val ? values.contractingExtension : '')
            setFieldValue(`${key}Fax`, val ? values.contractingFax : '')
            setFieldValue(`${key}EmailAddress`, val ? values.contractingEmailAddress : '')
            setTimeout(() => setFieldTouched(`${key}FirstName` || '', true))
          }

          return (
            <Form noValidate onSubmit={handleSubmit}>
              <Card>
                <Card.Body style={{ background: '#f7f7f7' }}>
                  <Card.Title>Contracting Contact (individual signing the contract)</Card.Title>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='contractingFirstName'
                        value={values.contractingFirstName}
                        isInvalid={!!errors.contractingFirstName}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.contractingFirstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='contractingLastName'
                        value={values.contractingLastName}
                        isInvalid={!!errors.contractingLastName}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.contractingLastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={4} md={4} sm={6} xs={6}>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        as={MaskedInput}
                        name='contractingPhoneNumber'
                        mask='(111) 111-1111'
                        value={values.contractingPhoneNumber}
                        isInvalid={!!errors.contractingPhoneNumber}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.contractingPhoneNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={2} md={2} sm={6} xs={6}>
                      <Form.Label>Extension</Form.Label>
                      <Form.Control
                        type='text'
                        name='contractingExtension'
                        value={values.contractingExtension || ''}
                        isInvalid={!!errors.contractingExtension}
                        onChange={handleChange}
                        disabled={readonly}
                        maxLength={4}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.contractingExtension}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Fax</Form.Label>
                      <Form.Control
                        type='text'
                        name='contractingFax'
                        isInvalid={!!errors.contractingFax}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.contractingFax}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type='text'
                        name='contractingEmailAddress'
                        value={values.contractingEmailAddress}
                        isInvalid={!!errors.contractingEmailAddress}
                        onChange={handleChange}
                        disabled={readonly}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.contractingEmailAddress}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
              <Card style={{ marginTop: 25 }}>
                <Card.Body style={{ background: '#f7f7f7' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Card.Title>Administrator Contact</Card.Title>
                    <div className='checkbox'>
                      <label title=''>
                        <Form.Check
                          type='checkbox'
                          style={{ marginLeft: 10 }}
                          checked={values.administratorSameAsContracting}
                          onChange={() => handleCheckboxChange('administrator', !values.administratorSameAsContracting, values)}
                          disabled={readonly}
                        />
                        Same as Contracting Contact
                      </label>
                    </div>
                  </div>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='administratorFirstName'
                        disabled={values.administratorSameAsContracting || readonly}
                        value={values.administratorFirstName}
                        isInvalid={!!errors.administratorFirstName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.administratorFirstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='administratorLastName'
                        disabled={values.administratorSameAsContracting || readonly}
                        value={values.administratorLastName}
                        isInvalid={!!errors.administratorLastName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.administratorLastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={4} md={4} sm={6} xs={6}>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        as={MaskedInput}
                        name='administratorPhoneNumber'
                        mask='(111) 111-1111'
                        disabled={values.administratorSameAsContracting || readonly}
                        value={values.administratorPhoneNumber}
                        isInvalid={!!errors.administratorPhoneNumber}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.administratorPhoneNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={2} md={2} sm={6} xs={6}>
                      <Form.Label>Extension</Form.Label>
                      <Form.Control
                        type='text'
                        name='administratorExtension'
                        value={values.administratorExtension || ''}
                        isInvalid={!!errors.administratorExtension}
                        onChange={handleChange}
                        disabled={values.administratorSameAsContracting || readonly}
                        maxLength={4}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.administratorExtension}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Fax</Form.Label>
                      <Form.Control
                        type='text'
                        name='administratorFax'
                        disabled={values.administratorSameAsContracting || readonly}
                        value={values.administratorFax}
                        isInvalid={!!errors.administratorFax}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.administratorFax}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type='text'
                        name='administratorEmailAddress'
                        disabled={values.administratorSameAsContracting || readonly}
                        value={values.administratorEmailAddress}
                        isInvalid={!!errors.administratorEmailAddress}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.administratorEmailAddress}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
              <Card style={{ marginTop: 25 }}>
                <Card.Body style={{ background: '#f7f7f7' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Card.Title>Billing Contact</Card.Title>
                    <div className='checkbox'>
                      <label title=''>
                        <Form.Check
                          type='checkbox'
                          style={{ marginLeft: 10 }}
                          checked={values.billingSameAsContracting}
                          onChange={() => handleCheckboxChange('billing', !values.billingSameAsContracting, values)}
                          disabled={readonly}
                        />
                        Same as Contracting Contact
                      </label>
                    </div>
                  </div>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='billingFirstName'
                        disabled={values.billingSameAsContracting || readonly}
                        value={values.billingFirstName}
                        isInvalid={!!errors.billingFirstName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.billingFirstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='billingLastName'
                        disabled={values.billingSameAsContracting || readonly}
                        value={values.billingLastName}
                        isInvalid={!!errors.billingLastName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.billingLastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={4} md={4} sm={6} xs={6}>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        as={MaskedInput}
                        name='billingPhoneNumber'
                        mask='(111) 111-1111'
                        disabled={values.billingSameAsContracting || readonly}
                        value={values.billingPhoneNumber}
                        isInvalid={!!errors.billingPhoneNumber}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.billingPhoneNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={2} md={2} sm={6} xs={6}>
                      <Form.Label>Extension</Form.Label>
                      <Form.Control
                        type='text'
                        name='billingExtension'
                        value={values.billingExtension || ''}
                        isInvalid={!!errors.billingExtension}
                        onChange={handleChange}
                        disabled={values.billingSameAsContracting || readonly}
                        maxLength={4}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.billingExtension}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Fax</Form.Label>
                      <Form.Control
                        type='text'
                        name='billingFax'
                        disabled={values.billingSameAsContracting || readonly}
                        value={values.billingFax}
                        isInvalid={!!errors.billingFax}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.billingFax}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type='text'
                        name='billingEmailAddress'
                        disabled={values.billingSameAsContracting || readonly}
                        value={values.billingEmailAddress}
                        isInvalid={!!errors.billingEmailAddress}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.billingEmailAddress}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
              <Card style={{ marginTop: 25 }}>
                <Card.Body style={{ background: '#f7f7f7' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Card.Title>Assessment Contact</Card.Title>
                    <div className='checkbox'>
                      <label title=''>
                        <Form.Check
                          type='checkbox'
                          style={{ marginLeft: 10 }}
                          checked={values.assessmentSameAsContracting}
                          onChange={() => handleCheckboxChange('assessment', !values.assessmentSameAsContracting, values)}
                          disabled={readonly}
                        />
                        Same as Contracting Contact
                      </label>
                    </div>
                  </div>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='assessmentFirstName'
                        disabled={values.assessmentSameAsContracting || readonly}
                        value={values.assessmentFirstName}
                        isInvalid={!!errors.assessmentFirstName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.assessmentFirstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='assessmentLastName'
                        disabled={values.assessmentSameAsContracting || readonly}
                        value={values.assessmentLastName}
                        isInvalid={!!errors.assessmentLastName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.assessmentLastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={4} md={4} sm={6} xs={6}>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        as={MaskedInput}
                        name='assessmentPhoneNumber'
                        mask='(111) 111-1111'
                        disabled={values.assessmentSameAsContracting || readonly}
                        value={values.assessmentPhoneNumber}
                        isInvalid={!!errors.assessmentPhoneNumber}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.assessmentPhoneNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={2} md={2} sm={6} xs={6}>
                      <Form.Label>Extension</Form.Label>
                      <Form.Control
                        type='text'
                        name='assessmentExtension'
                        value={values.assessmentExtension || ''}
                        isInvalid={!!errors.assessmentExtension}
                        onChange={handleChange}
                        disabled={values.assessmentSameAsContracting || readonly}
                        maxLength={4}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.assessmentExtension}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Fax</Form.Label>
                      <Form.Control
                        type='text'
                        name='assessmentFax'
                        disabled={values.assessmentSameAsContracting || readonly}
                        value={values.assessmentFax}
                        isInvalid={!!errors.assessmentFax}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.assessmentFax}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type='text'
                        name='assessmentEmailAddress'
                        disabled={values.assessmentSameAsContracting || readonly}
                        value={values.assessmentEmailAddress}
                        isInvalid={!!errors.assessmentEmailAddress}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.assessmentEmailAddress}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
              <Card style={{ marginTop: 25 }}>
                <Card.Body style={{ background: '#f7f7f7' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Card.Title>Quality Contact</Card.Title>
                    <div className='checkbox'>
                      <label title=''>
                        <Form.Check
                          type='checkbox'
                          style={{ marginLeft: 10 }}
                          checked={values.qualitySameAsContracting}
                          onChange={() => handleCheckboxChange('quality', !values.qualitySameAsContracting, values)}
                          disabled={readonly}
                        />
                        Same as Contracting Contact
                      </label>
                    </div>
                  </div>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='qualityFirstName'
                        disabled={values.qualitySameAsContracting || readonly}
                        value={values.qualityFirstName}
                        isInvalid={!!errors.qualityFirstName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.qualityFirstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type='text'
                        name='qualityLastName'
                        disabled={values.qualitySameAsContracting || readonly}
                        value={values.qualityLastName}
                        isInvalid={!!errors.qualityLastName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.qualityLastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={4} md={4} sm={6} xs={6}>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        as={MaskedInput}
                        name='qualityPhoneNumber'
                        mask='(111) 111-1111'
                        disabled={values.qualitySameAsContracting || readonly}
                        value={values.qualityPhoneNumber}
                        isInvalid={!!errors.qualityPhoneNumber}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.qualityPhoneNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={2} md={2} sm={6} xs={6}>
                      <Form.Label>Extension</Form.Label>
                      <Form.Control
                        type='text'
                        name='qualityExtension'
                        value={values.qualityExtension || ''}
                        isInvalid={!!errors.qualityExtension}
                        onChange={handleChange}
                        disabled={values.qualitySameAsContracting || readonly}
                        maxLength={4}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.qualityExtension}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Fax</Form.Label>
                      <Form.Control
                        type='text'
                        name='qualityFax'
                        disabled={values.qualitySameAsContracting || readonly}
                        value={values.qualityFax}
                        isInvalid={!!errors.qualityFax}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.qualityFax}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type='text'
                        name='qualityEmailAddress'
                        disabled={values.qualitySameAsContracting || readonly}
                        value={values.qualityEmailAddress}
                        isInvalid={!!errors.qualityEmailAddress}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.qualityEmailAddress}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}>
                {
                  !readonly ? (
                    <Button
                      variant='secondary'
                      style={{ width: '115px' }}
                      type='submit'
                    >
                      Save & Exit
                    </Button>
                  ) : null
                }
                <div>
                  <Button
                    variant='secondary'
                    style={{ width: '115px', marginRight: 10 }}
                    onClick={() => handleBack(values)}
                  >
                    Previous
                  </Button>
                  <Button
                    variant='info'
                    style={{ width: '115px', marginRight: 10 }}
                    onClick={() => handleNextClicked()}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default ContactInfo